export default __webpack_public_path__ + "assets/_Chapters/Referenzen/max-boegel.png";